import { Box, Image, keyframes, usePrefersReducedMotion, Tag, TagLabel, Button } from '@chakra-ui/react'
import { ChevronDownIcon, ArrowForwardIcon } from '@chakra-ui/icons'
import copertina from '../images/img_locandina_senza_sfondo.png'
import calamo from '../images/Copertura-del-fiume-Calamo.jpg'
import piazzaMarconi_2 from '../images/108.jpg'
import { useNavigate } from "react-router-dom";

const floating = keyframes`
  0% { transform: translatey(0px) }
  50% { transform: translatey(-20px) }
  100% {translatey(0px)}
`

const Hello = ({ handleClick }) => {
    const navigate = useNavigate();

    const prefersReducedMotion = usePrefersReducedMotion();
    const animation = prefersReducedMotion
        ? undefined
        : `${floating} infinite 2.5s linear`

    const toProgram = () => {
        navigate('/programma');
    }

    return (
        <Box width='100%' height={['auto', null, '850px']} position='relative' mb={[6, null, 12]}>

            <Tag
                size='lg'
                borderRadius='full'
                variant='solid'
                colorScheme='green'
                position='absolute'
                top={2}
                left={2}
                shadow='lg'
            >
                <TagLabel>Beta</TagLabel>
            </Tag>

            <Image src={copertina} position='absolute' height={['650px', null, '1700px']} />

            <Box display='flex' flexDir={['column', 'column', 'column', 'row']} bgGradient="linear(to-r, green.600, green.400)">
                <Image maxH={['300px', null, '400px', '850px']} w='100%' src={calamo} objectFit='cover' opacity='0.1' />
                <Image maxH={['300px', null, '400px', '850px']} w='100%' src={piazzaMarconi_2} objectFit='cover' opacity='0.1' />
            </Box>

            <Button
                rightIcon={<ArrowForwardIcon />}
                onClick={toProgram}
                position='absolute'
                bottom={[10, null, '70px', 10]}
                right={[3, null, 10]}
                colorScheme='green'
                textColor='white'
            >
                Vedi il programma
            </Button>




            <Box position='absolute' w='100%' display='flex' justifyContent='center' animation={animation} bottom={['-30px', '0', '-30px']} onClick={handleClick}>
                <ChevronDownIcon w={[10, 20, 12]} h={[10, 20, 12]} textColor='white' borderRadius='full' />
            </Box>
        </Box>
    )
}

export default Hello